import { ProgressSpinner } from 'primereact/progressspinner';
import './spinner.styles.css';

type SpinnerProps = {
	/**
	 * `inline`: small indicator for use next to text (e.g. route refresh).
	 * `default`: dialog / blocking layout with card chrome.
	 */
	size?: 'default' | 'inline';
};

const Spinner = ({ size = 'default' }: SpinnerProps) => {
	if (size === 'inline') {
		return (
			<span className="inline-flex shrink-0 text-primary60" aria-hidden>
				<ProgressSpinner
					className="spinner-inline"
					strokeWidth="3px"
					animationDuration="1s"
				/>
			</span>
		);
	}

	return (
		<ProgressSpinner
			className="spinner-container"
			strokeWidth="4px"
			animationDuration="2s"
		/>
	);
};

export default Spinner;
